export default __webpack_public_path__ + "static/media/howItWorks2.4b83cba2.png";